import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import { RCUtils } from '../../../RCUtils';
import $ from 'jquery';
import Switch from 'react-toggle-switch';
import CommonActions from '../../../actions/CommonActions';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface HumidityGridState {
    SelectedReefers: any[];
    HumValue: string;
    RowData: server.USP_UnitCurrentConditionUI_Model[];
    Filters: server.ForwardCommandParameters;
    VCCheckBoxInfo: VCCheckBoxData;
    isHumidityEnable: boolean;
    isDeHumidityEnable: boolean;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

export class HumiditySetPoint extends React.Component<any, HumidityGridState> {
    constructor(props: any) {
        super(props);
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        this.state = { SelectedReefers: [], HumValue: "0", RowData: [], Filters: filterSet, VCCheckBoxInfo: emptyVCCheckBoxData, isHumidityEnable: false, isDeHumidityEnable: false, IsCommandIssued: false, PrevSelectedItems: [] };
    }

    componentDidMount() {
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            this.renderHumiditySetPointGrid(this.props.reeferData);
            this.checkHumiditySetPoint(this.props.reeferData);
        }

        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }

        $('#globalLoader').hide();
    }

    checkHumiditySetPoint(reeferData: any) {
        var daikinCount = CommonActions.validateOEMType('D', reeferData);
        if (daikinCount > 0) {
            //$('#globalLoader').show();

            //var filterSet = new ReeferHistoryFilter();

            //if (reeferData[0].EventDTTM != null && reeferData[0].EventDTTM != "") {
            //    var toDTTM = Formatters.DateTimeFormatter(reeferData[0].EventDTTM);
            //    var modifiedDttm = new Date(toDTTM);
            //    modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            //    var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
            //    var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            //    var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            //    filterSet.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            //    filterSet.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            //}
            //else {
            //    var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
            //    var toDTTM = Formatters.DateTimeFormatter(currentUtcDttm);
            //    var modifiedDttm = new Date(toDTTM);
            //    modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            //    var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
            //    var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            //    var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            //    filterSet.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            //    filterSet.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            //}

            //filterSet.Units = reeferData[0].UnitMasterID;

            //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: JSON.stringify(filterSet), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //fetch(request)
            //    .then(RCUtils.handleError)
            //    .then(response => response.json() as Promise<server.UnitHistoryUI[]>)
            //    .then(data => {   
            //        if (data != null && data != undefined && data.length > 0) {
            //            if (data[0].Humidity != null && data[0].Humidity != undefined && data[0].Humidity > 0) {
            //                this.setState({ isDeHumidityEnable: true, isHumidityEnable: true, HumValue: data[0].Humidity.toString() }, () => $('#globalLoader').hide());
            //            }
            //            else {
            //                this.setState({ isDeHumidityEnable: true, isHumidityEnable: false, HumValue:"0" }, () => $('#globalLoader').hide());
            //            }
            //        }
            //        else {
            //            this.setState({ isDeHumidityEnable: true, isHumidityEnable: false, HumValue: "0" }, () => $('#globalLoader').hide());
            //        }
            //    });

            var humiditySetValue = reeferData[0].HumiditySetpoint;
            if (humiditySetValue != null && humiditySetValue != "" && humiditySetValue != "-999") {
                if (reeferData.filter(row => row.HumiditySetpoint == humiditySetValue).length == reeferData.length)
                    this.setState({ isDeHumidityEnable: true, isHumidityEnable: true, HumValue: humiditySetValue });
                else
                    this.setState({ isDeHumidityEnable: true, isHumidityEnable: false, HumValue: "0" });
            }
            else
                this.setState({ isDeHumidityEnable: true, isHumidityEnable: false, HumValue: "0" });
        }
        else
            this.setState({ isDeHumidityEnable: false, isHumidityEnable: false, HumValue: "0" });
    }

    closeConfirmation() {
        $("#confirmPopUpModel").css("display", "none");
    }

    submitCommandSetPoint(command: string, paramValue: string) {
        var refreshGrid = this.props.refreshGrid;
        ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid);
        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
    }

    submitHumSetPoint() {
        if (this.state.RowData.length > 0) {
            var paramValue = this.state.HumValue;
            if (this.state.RowData.filter(row => row.DeviceType != null && row.DeviceType != undefined && (row.DeviceType.toString().trim() == 'CT4000' || row.DeviceType.toString().trim() == 'CT5000')).length > 0) {
                if (paramValue != "" && paramValue != null) {
                    if (parseInt(paramValue) < 50 || parseInt(paramValue) > 95) {
                        PopupWindow.showErrorMessage("Alert", "Setpoint value should be with in range (50-95)."); return
                    }
                }
                else {
                    PopupWindow.showErrorMessage("Alert", "Please enter valid Setpoint value."); return
                }
            }
            var command = "Humidity";
            if (this.state.isDeHumidityEnable) {
                if (this.state.isHumidityEnable) {
                    if (paramValue != "" && paramValue != null) {
                        if (paramValue == "0") {
                            PopupWindow.showErrorMessage("Alert", "To disable dehumidification, please select OFF.");
                            //RCNGWindow.ConfirmWindow.showConfirmBox("To disable dehumidification, please select OFF.", this.submitCommandSetPoint.bind(this, command, paramValue), this.closeConfirmation.bind(this));
                        }
                        else {
                            var refreshGrid = this.props.refreshGrid;
                            ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid);
                            this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                        }
                    }
                    else
                        PopupWindow.showErrorMessage("Alert", "Please enter valid Setpoint value.");
                }
                else {
                    paramValue = "0";
                    var refreshGrid = this.props.refreshGrid;
                    ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid);
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                }
            }
            else {
                if (paramValue != "" && paramValue != null) {
                    var refreshGrid = this.props.refreshGrid;
                    ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid);
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Please enter valid Setpoint value.");
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.renderHumiditySetPointGrid(reeferData);
            this.checkHumiditySetPoint(nextprops.reeferData);
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    renderHumiditySetPointGrid(reeferData: any) {
        this.setState({ RowData: reeferData, HumValue: "0" });
        this.state.Filters.CommandName = "Humidity";
        this.state.Filters.SelectedReefers = reeferData;
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
    }

    humChange(event: React.FormEvent<HTMLInputElement>) {
        var humVal = this.state.HumValue;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value))
            humVal = Value;
        else
            return;
        this.setState({ HumValue: humVal });
    }

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "Humidity", TempValue: "", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };
        return filters;
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }

    toggleSwitch = (el) => {
        this.setState(prevState => {
            return {
                isHumidityEnable: !prevState.isHumidityEnable
            };
        });
        this.setState({ HumValue: "0" });
    }

    renderHumidityHtml() {
        if (this.state.isDeHumidityEnable) {
            return <div>
                <div className="row">
                    <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                        <div className="row">
                            <div className='col-lg-5 col-md-7 col-sm-7 col-xs-6 text-start text-sm-end pe-0'>
                                <span className='col-form-label'>De-Humidification :</span>
                            </div>
                            <div className='col-lg-4 col-md-5 col-sm-5 col-xs-6'>
                                <Switch className='swith-humidity' onClick={this.toggleSwitch.bind(this)} on={this.state.isHumidityEnable} />
                            </div>
                        </div>
                    </div>
                    {this.renderDehumidityHtml()}
                </div>

            </div>;
        }
        else {
            return <div className='row'>
                <div className='col-lg-4 col-md-4 text-sm-end pe-0'>
                    <label className='col-form-label'>Enter the valid percentage :</label>
                </div>
                <div className='col-lg-4 col-md-4'>
                    <input type='text' className='form-control width70' maxLength={4} placeholder='' required onChange={e => this.humChange(e)} value={this.state.HumValue} />
                </div>
            </div>;
        }
    }

    renderDehumidityHtml() {
        if (this.state.isHumidityEnable) {
            return <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                <div className="row">
                    <div className='col-lg-5 col-md-6 col-sm-6 col-xs-6 text-start text-sm-end pe-0'>
                        <label className='col-form-label'>Humidity setpoint :</label>
                </div>
                    <div className='col-lg-4 col-md-6 col-sm-6 col-xs-6'>
                    <input type='text' className='form-control' placeholder='' required onChange={e => this.humChange(e)} value={this.state.HumValue} />
                </div>
                </div>
            </div>;
        }
        else {
            return '';
        }
    }

    public render() {
        return <div>
            <div className="modal-controls-container">{this.renderHumidityHtml()}
            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.RowData} commandName={"Humidity"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitHumSetPoint.bind(this)}>Save</button>
            </div>
        </div>
    }
}

class ReeferHistoryFilter {
    FromDate: string;
    ToDate: string;
    Units: string;
}
